import React, { Component } from 'react';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';

import Mockup from '../../assets/images/Mockup.png';
import TVH from '../../assets/images/pic1.png';
import HFA from '../../assets/images/pic2.png';
import SSE from '../../assets/images/pic3.png';
import COT from '../../assets/images/pic4.png';
import ENS from '../../assets/images/pic5.png';
import arrow from '../../assets/images/arrowCardRight.svg';
import arrowTalk from '../../assets/images/arrow-talk.svg';
import backgroundQuote from '../../assets/images/backgroundQuote.png';


import './homePage.scss';

export default class HomePage extends Component {

  constructor(props) {
    super(props);
    configureAnchors({ scrollDuration: 900 })
  }

  render() {
    return (
      <div className="container-home-page">
        <div className="container">
          <ScrollableAnchor id="about-us">
            <div className="row" >
              <div className="col-md-10 mx-auto ">
                <h2 className="slogan-wizy text-center">Wizy helps develop digital business more efficiently, powered by Vietnamese digital top talents.</h2>
                <p className="description text-center">We focus on Web Development, App Development and UI Design with highly proficiency.</p>
              </div>
              <div className="col-md-9 col-sx-12 mx-auto ">
                <img className="img-responsive img-fluid" src={Mockup} alt="" />
              </div>
            </div>
          </ScrollableAnchor>
          <ScrollableAnchor id="our-projects">
            <div className="row">
              <div className="col-md-9 mx-auto">
                <h6 className="section-title text-center">OUR PROJECTS</h6>
                <p className="description text-center">We focus on quality from early stages of the project life cycle. We deliver "Zero-Defect" products that sparkle with quality.</p>
              </div>
              <div className="col-md-5 mx-auto">
                <img className="img-responsive" src={TVH} alt="" />
                <h6 className="project-title text-left">
                  Travel Hub
                </h6>
                <p className="project-description text-left">Mobile App Development, UI Design, Wizy Innovation</p>
                <img className="img-responsive" src={SSE} alt="" />
                <h6 className="project-title text-left">
                  Security Selfie
                <a href="https://www.securityselfie.ch/" target="_blank"><img src={arrowTalk} alt="" /></a>
                </h6>
                <p className="project-description text-left">UI & UX Design, Website Development</p>
                <img className="img-responsive" src={ENS} alt="" />
                <h6 className="project-title text-left">
                  English Speak
                </h6>
                <p className="project-description text-left">App Design & Development, Wizy Innovation</p>
              </div>
              <div className="col-md-5 v-align-image">
                <div className="hand-for-affrica">
                  <img className="img-responsive" src={HFA} alt="" />
                  <h6 className="project-title text-left">
                    Hand for Africa
                  <a href="http://www.handfuerafrika.ch/" target="_blank"><img src={arrowTalk} alt="" /></a>
                  </h6>
                  <p className="project-description text-left">UI & UX Re-Design, Website Development</p>
                  <img className="img-responsive" src={COT} alt="" />
                  <h6 className="project-title text-left">
                    Coin Tracking
                  </h6>
                  <p className="project-description text-left">App Design & Development, Wizy Innovation</p>
                </div>
              </div>
            </div>
          </ScrollableAnchor>
          <hr />
          <ScrollableAnchor id="our-services">
            <div>
              <div className="row">
                <div className="col-md-9 mx-auto">
                  <h6 className="section-title text-center">OUR SERVICES</h6>
                  <p className="description text-center">You're seeking human. You want to have professional and skillful talents/staff for projects but don't want to waste too much time, money to conduct process of recruitment, training, termination. Let Wizy support and corporate with you.</p>
                </div>
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-md-3 col-sm-12 no-padding">
                    <div className="card-services card-services-first">
                      <h6 className="card-title text-left">Website Design & Development</h6>
                      <div className="card-content">
                        <p className="text-left">We are highly proficient with Full JavaScript Stack (ReactJS, AngularJS, EmberJS, HTML5, CSS3, SCSS, NodeJS, Java), which makes us the ideal candidate for your web application development projects.</p>
                      </div>
                      <div className="card-icon">
                        <img src={arrow} alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-12 no-padding">
                    <div className="card-services card-services-second">
                      <h6 className="card-title text-left">Mobile App Design  & Development</h6>
                      <div className="card-content">
                        <p className="text-left">Write once run anywhere: We build world class cross-platform (e.g. Android, iOS) apps using React Native, as well as mobile sites using Angular & Ionic Cordova.</p>
                      </div>
                      <div className="card-icon">
                        <img src={arrow} alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-12 no-padding">
                    <div className=" card-services card-services-third">
                      <h6 className="card-title text-left">UI / UX Design</h6>
                      <div className="card-content">
                        <p className=" text-left">Our talented designers can read your mind. We offer state-of-the-art UI/UX experience with highly usability. </p>
                      </div>
                      <div className="card-icon">
                        <img src={arrow} alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-12 no-padding">
                    <div className="card-services card-services-fourth">
                      <h6 className="card-title text-left">Dedicated Team</h6>
                      <div className="card-content">
                        <p className=" text-left">Our inhouse engineers can be engaged on short / long contractual periods to support on more traditional project development or to cover when our clients face demand peaks with unusually high work loads.</p>
                      </div>
                      <div className="card-icon">
                        <img src={arrow} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ScrollableAnchor>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="quote-container col-md-12 no-padding">
              <div className="quote">
                <img className="background-quote img-responsive img-fluid" src={backgroundQuote} alt="" />
                <div className="quote-content">
                  <h6 className="quote-title text-center">OUR CUSTOMER SATISFIED WITH OUR WORK</h6>
                  <div className="col-md-6 mx-auto">
                    <div className="quote-content-details">
                      <p className="primary-italic-font text-center">
                      Wizy Vietnam delivered on the project requirements and consistently provided reliable designs and code. When specialized knowledge or experience was required, they easily found appropriate additions to the team.
                      </p>
                    </div>
                  </div>
                  <div className="quote-author">
                    <p className=" text-center">Michael Müller</p>
                  </div>
                  <div className="quote-company">
                    <p className=" text-center">CEO, IT Consultancy</p>
                  </div>
                  <div className="more-review text-center">
                    <a target="_blank" href="https://clutch.co/profile/wizy-vietnam#reviews">See detailed review on Clutch.co here</a>
                  </div>

                  <div className="more-review text-center">
                    <a target="_blank" href="https://www.designrush.com/agency/web-development-companies/">We are recognized as a Top Website Development Company on DesignRush</a>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="contact-content text-center">
              <h6 className="section-title text-center">WE HOPE YOU ARE THE NEXT</h6>
              <h6 className="contact-description primary-light-font text-center">If you have any idea which want to discuss. Please feel free to contact us.</h6>

              <button type="button" className="btn btn-link btn-talk" onClick={() => { window.location.href = "skype:live:info_680348?chat" }}>
                Let's Talk <span><img src={arrowTalk} alt="" /></span>
              </button>

            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/HomePage/HomePage.js